import { fromPairs, identity, into } from 'ramda'

const read = () =>
  fromPairs(into([], identity, new URLSearchParams(window.location.search)))

export { read }
